import request from 'src/request/request';
import { toast } from 'src/utils/notification';

export const checkSession = async () => {
  const { valid } = await request(false, 'GET', 'public/check-session', {});
  if (valid) {
    toast.warning('Your are logged in');
    return window.location.href = '/app';
  }
};